import React from "react";
import "./menu.css";
import separador from "../../media/Icon-ChevronRight12-White.svg";
import { withRouter } from "react-router";

class MenuLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: props.opciones,
    };
  }

  cambiaPantalla(url) {
    this.props.history.push(url);
  }

  render() {
    return (
      <div className="form__container--ayuda-menu-link-container">
        {this.state.opciones.map((opcion, i) => {
          return (
            <React.Fragment key={"opcion-menu-link-" + i}>
              {opcion.titulo !== "Inicio" &&
              opcion.hash !== this.props.location.hash ? (
                ""
              ) : (
                <React.Fragment>
                  <div
                    className={opcion.hash === this.props.location.hash ? "form__container--ayuda-menu-link activo":"form__container--ayuda-menu-link"}
                    onClick={() => {
                      this.cambiaPantalla(opcion.url);
                    }}
                  >
                    {opcion.titulo}
                  </div>
                  <img className={opcion.hash === this.props.location.hash ?"form__container--ayuda-menu-separador activo":"form__container--ayuda-menu-separador"} src={separador} alt="separador" />
                </React.Fragment>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

export default withRouter(MenuLink);
